import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const AlmondcoDespatchDataService = {
  async dataSourceConfig(SalesOrderNo, LineNo) {
    // var url = "api/AlmondcoInshellAssignedDespatchData";
    // return ApiService.createDataSource(url, params);


    const requestScreenData = {
      url: "api/AlmondcoInshellAssignedDespatchData",
      filter: `SalesOrderNo eq ${SalesOrderNo} and SalesOrderLine eq ${LineNo}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getLotAssignment(SalesOrderNo, ItemCode) {

    const requestScreenData = {
      url: "api/AlmondcoInshellSalesOrderLotAssignment",
      filter: `SalesOrderCode eq ${SalesOrderNo} and ItemCode eq '${ItemCode}'`,
      top: 1
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async dataSourceConfigQCData(DeliveryNote, LineNo) {

    const requestScreenData = {
      url: "api/AlmondcoQcDespatchData",
      filter: `DeliveryNote eq ${DeliveryNote} and DeliveryNoteLineNo eq ${LineNo}`
    };

    return await ApiService.oDataGet(requestScreenData);
  },


  async checkQCData(DeliveryNote) {

    const requestScreenData = {
      url: "api/AlmondcoQcDespatchData",
      filter: `DeliveryNote eq ${DeliveryNote}`
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getFromPickingSlip(SalesOrderCode, ItemCode) {

    const requestScreenData = {
      url: "api/PickingSlipDetail",
      filter: `SalesOrderCode eq ${SalesOrderCode} and ItemCode eq '${ItemCode}'`,
      top: 1,
      select: ["StockUMSuppliedQty", "SalesOrderCode", "ItemCode", "LineNo"]
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async SaveAlmondcoWriteDespatchData(payload) {

    var url = `api/Save_AlmondcoWriteDespatchData`;
    return await ApiService.post(url, payload);
  }


};

export { AlmondcoDespatchDataService };
